<template>
    <div>
        <b-card class="bg-default-card no-padding">
            <b-tabs card>
                <b-tab :title="uLang('app.candidates')">
                    <coach-trajectory-enrolments-tab
                            :apiUrl="route('relations.trajectory-enrolments.table', { relation: id })"
                    />
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>

<script>
    import { DocumentsTab, LocationsTab, LogsTab, CoachTrajectoryEnrolmentsTab } from '~/components/tabs'
    import SuccessAlert from '~/Swals/SuccessAlert'
    import AddressesDisplay from '~/components/addresses/display';
    import TrajectoryEnrolmentTable from '~/components/tables/admin/relation/trajectory-enrolment/table'
    import RelationInfoTable from '~/components/relations/basic-info-table'

    export default {
        name: 'coach-candidates',

        components: {
            CoachTrajectoryEnrolmentsTab,
        },

        props: {
            id: {
                required: true,
            },
        },
    }
</script>

<style lang="css" scoped>
</style>
